import { useEffect } from "react";
import styled from "styled-components";
import {
  createCounter,
  getRemainingArticlesProps,
} from "./TestBuyDetailsHelper";
import { Trans } from "@coworker/locales";
import { TestbuyItemsListView } from "@coworker/apprestructured/src/testbuy/components/TestbuyItemsListView/TestbuyItemsListView";
import { TestbuyItems } from "@coworker/apprestructured/src/testbuy/types/testbuyItems";
import {
  TestBuy,
  TestBuyProductWithCriteria,
} from "@coworker/types/lib/testbuy";

const RemainingHeader = styled("h3")`
  padding: 1rem 1.5rem 1rem 2rem;
  border-bottom: 1px solid var(--grey150);
`;

interface RemainingArticlesProps extends TestbuyItems {
  onDone: (testbuyId: string) => Promise<unknown>;
  testbuy: TestBuy;
}

export default function RemainingArticleList({
  testbuyItems,
  testbuy,
  onDone,
}: RemainingArticlesProps) {
  const testbuyId = testbuy.id;
  const remainingArticlesProps = getRemainingArticlesProps(testbuyItems);
  const isDone =
    remainingArticlesProps.testbuyItems.length === 0 && testbuyItems.length > 0;
  useEffect(() => {
    if (isDone) onDone(testbuyId);
  }, [isDone, onDone, testbuyId]);

  return (
    //This div exist due to render issues on RDT
    <div data-testid="remaining-article-list">
      <RemainingHeader>
        <Trans>remaining</Trans>{" "}
        <span data-testid="remaining-articles-count">
          {createCounter(
            remainingArticlesProps.testbuyItems.length,
            testbuyItems.length
          )}
        </span>
      </RemainingHeader>
      <TestbuyItemsListView
        testbuy={testbuy}
        filteredTestbuyItems={remainingArticlesProps.testbuyItems}
        allTestbuyItemNos={testbuyItems.map(
          (item: TestBuyProductWithCriteria) => item.shortId
        )}
      />
    </div>
  );
}
